let id = 0;

export const uniqueId = () => {
  id += 1;
  return id;
};
